import { useMemo } from 'react'
import { createTheme, useTheme, type Theme } from '@mui/material/styles'

import { calculatorPopperBoundsModifier, calculatorPopperSurfaceStyles } from './scaled-popper'

const createPopupTheme = createTheme as unknown as (
  baseTheme: Theme,
  overrides: CalculatorPopupThemeOverrides,
) => Theme

export const useCalculatorPopupTheme = (enabled: boolean) => {
  const theme = useTheme()

  return useMemo(() => {
    if (!enabled) return theme

    return createPopupTheme(theme, {
      components: {
        MuiPopper: {
          styleOverrides: {
            root: calculatorPopperSurfaceStyles,
          },
          defaultProps: {
            popperOptions: {
              modifiers: [ calculatorPopperBoundsModifier ],
            },
          },
        },
        MuiPopover: {
          defaultProps: {
            slotProps: {
              paper: {
                'data-calculator-select': 'true',
              },
            },
          },
        },
      },
    })
  }, [ enabled, theme ])
}
